// API Service para solicitudes del portal cliente
// Endpoints: /solicitudes/pendientes, /solicitudes/mis-solicitudes, /expedientes/{id}/solicitudes/{sid}

import { api } from './api';
import type {
  ExpedienteSolicitudRead,
  ExpedienteSolicitudUpdate,
} from '@/types/expedienteSolicitud';

export const clienteSolicitudesService = {
  /** GET /solicitudes/pendientes — solicitudes pendientes del cliente auth */
  getPendientes: async (): Promise<ExpedienteSolicitudRead[]> => {
    const res = await api.get('/solicitudes/pendientes');
    return res.data;
  },

  /** GET /solicitudes/mis-solicitudes — todas las solicitudes del cliente */
  getMisSolicitudes: async (): Promise<ExpedienteSolicitudRead[]> => {
    const res = await api.get('/solicitudes/mis-solicitudes');
    return res.data;
  },

  /** PUT /expedientes/{eid}/solicitudes/{sid} — responder solicitud */
  responder: async (
    expedienteId: string,
    solicitudId: string,
    data: ExpedienteSolicitudUpdate
  ): Promise<ExpedienteSolicitudRead> => {
    const res = await api.put(`/expedientes/${expedienteId}/solicitudes/${solicitudId}`, data);
    return res.data;
  },
};
